import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { Provider } from 'react-redux';
import { clearReduxDataForHomeComponent } from './redux/actions/home_action';
import { clearReduxDataForUserComponent } from './redux/actions/user_actions';

window.addEventListener('beforeunload', () => {
  store.dispatch(clearReduxDataForHomeComponent());
  store.dispatch(clearReduxDataForUserComponent())
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
